<astrea-internal-banner
    title="{{ 'purchases.success.thanks' | translate }}"
></astrea-internal-banner>

<div class="page-purchases content-height m-sm-4 m-2">

    <div *ngIf="redirectOK; else astreaLoading" class="page-width">

        <div class="mb-3">
            <img class="img-responsive" src="/assets/images/astrea-brand/astrea-logo-green.png" alt="{{ 'logo' | translate }}">
        </div>

        <div class="astrea-title t-center mt-3">
            <h1>{{ 'purchases.success.thanks' | translate }}</h1>
        </div>

        <div class="mt-4 mb-2">
            <p *ngIf="purchase.category == 'house'">
                {{ 'purchases.success.text_1' | translate }} <strong><a href="https://g.page/EditorialAstrea?share" target="_blank" title="{{ 'purchases.success.locate' | translate }}">Lavalle 1208 (C1048AAF) - CABA</a></strong> {{ 'purchases.success.text_2' | translate }}
                <br>
            </p>
            <p *ngIf="purchase.category == 'correo-argentino'">
                {{ 'purchases.success.text_3' | translate }} <strong>{{ purchase.vUser.addressResidence }} ({{ purchase.vUser.postalCodeResidence }}) - {{ purchase.vUser.cityResidence }}, {{ getCountry(purchase.vUser.nationality) }}</strong> {{ 'purchases.success.correo_argentino' | translate }}
                <br>
            </p>
        </div>

        <a routerLink="/home" class="btn btn-green mt-5" mat-button>
            {{ 'purchases.success.continue' | translate }}
        </a>

    </div>

    <ng-template #astreaLoading>
        <astrea-loading class="mt-5"></astrea-loading>
    </ng-template>

</div>
